// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Uv4Q5UZfe5vUGeElBbeV5","leftPanel":"_1HDyYh9ECfGWKf3NWccCX4","rightPanel":"dGzTWc_X2JxCLp3jofm8a","leftPanelShiftMobile":"_18Nt-y0wcC18-KSt4TyDPw"};